import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { useHistory } from "react-router";

import Card from "../../Common/custom_card";
import MarkerBasicDetail from "./marker_basic_detail";
import { getPropertyById } from "../../../controllers/snowm_firebase";

const ServicePointItem = ({ marker }) => {
  const dummyImageData =
    "data:image/jpeg;base64,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";

  const [property, setProperty] = useState();

  const history = useHistory();

  useEffect(() => {
    let isSubscribe = true;
    if (marker?.propertyKey) {
      getPropertyById(marker?.propertyKey).then((res) => {
        if (isSubscribe && res?.length > 0) setProperty(res[0]);
      });
    }

    return () => {
      isSubscribe = false;
    };
  }, [marker]);

  function handleItemClick(e) {
    e.stopPropagation();
    history.push(`/home/markers/${marker.key}`);
  }

  return (
    <Card padding="1em 1em 0 1em" onPress={handleItemClick} minHeight="450px">
      <StyledImage
        component="img"
        alt=""
        height={200}
        width="100%"
        src={marker?.imageUrl ? marker?.imageUrl : dummyImageData}
      />

      <MarkerBasicDetail markerPage marker={marker} property={property} />
    </Card>
  );
};
export default ServicePointItem;

const StyledImage = styled.img`
  object-fit: cover;
`;
